<app-header [selectedMenu]="MENU_PAGE.SASEUNG"></app-header>

<div class="container" (scroll)="onScrollTop($event)">

  <!-- div class="wrapper" #main
       (click)="onFocusMain($event)" -->
  <div class="wrapper">

    <aside class="rope"
           (click)="onClickRope($event)">
      <div class="up-arrow"></div>
    </aside>
    <app-back-btn></app-back-btn>

    <section class="schedule">
      <div class="inner wrap">

        <div #extContainer
             class="schedule-hanja flex-column">

          <app-jaso-index-seungjo #extHeader
                                  [curJasoIdx]="curJasoIdx"
                                  (search)="onSearch($event)"></app-jaso-index-seungjo>

          <article class="schedule-table">

            <div #extBody
                 class="table-wrap">

              <div #container
                   class="word-list scroll-effect over-y {{ isShowScrollbar ? 'scrollbar' : '' }}"
                   *ngIf="ll?.getTotalCount() !== 0"
                   (scroll)="onScroll($event)">
                <div *ngFor="let saseung of ll?.getList()"
                     class="word-box"
                     [class.on]="saseung === curHangul"
                     [attr.aria-current]="saseung === curHangul ? 'true' : null"
                     role="button"
                     [attr.data-text]="saseung"
                     (click)="onSelectChar($event, saseung)">{{ saseung }}</div>

                <!-- 로딩중 표시 -->
                <div class="reload-icon" *ngIf="! ll?.IsComplete()">
                  <img #reload src="assets/img/loading_icon.gif">
                </div>
              </div>
            </div>

            <!-- 로딩 항목이 없을 때 -->
            <div class="no-result-box" *ngIf="ll?.IsComplete() && ll?.getList()?.length === 0">
              <div class="no-result">
                <div class="no-result-img"></div>
                <div class="no-result-txt">문자가 없습니다.</div>
              </div>

            </div>

          </article>


        </div>

        <div #detailList class="schedule-contents flex-column">

          <app-search-box-saseung #searchBox
                                  [placeholder]="placeholder"
                                  [keyword]="keyword"
                                  [keyHistoryKeyword]="HISTORY_KEY_SEARCH_SASEUNG"
                                  [top]="scrollTop"
                                  (search)="onSearch($event)"></app-search-box-saseung>

          <!-- 도움말 -->
          <app-saseung-help-btn></app-saseung-help-btn>

          <app-saseung-detail [hangul]="curHangul ?? null"
                              [keyword]="keyword"
                              [hun]="hun"
                              [hanja]="hanja">
<!--                              [selected]="keyword"-->
          </app-saseung-detail>

        </div>


      </div>
    </section>


  </div>

  <!-- app-footer></app-footer -->
  <app-common-popups></app-common-popups>

</div>
